// index.tsx
import React, { useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface"; // Ensure correct path

const Datatable: React.FC<DatatableProps> = ({ columns, dataSource, rowKey, className, pagination, loading, rowSelection: customRowSelection }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // Use custom rowSelection if provided, otherwise use default, or false to disable
  let rowSelection;
  if (customRowSelection === false) {
    rowSelection = undefined; // Disable row selection
  } else if (customRowSelection) {
    rowSelection = customRowSelection; // Use custom row selection
  } else {
    // Default behavior (backward compatibility)
    rowSelection = {
      selectedRowKeys,
      onChange: onSelectChange,
    };
  }

  // Ensure dataSource is an array
  const safeDataSource = Array.isArray(dataSource) ? dataSource : [];

  // Use provided rowKey function or fallback to default
  const getRowKey = rowKey || ((record: any) => record.id || record.key || `row-${safeDataSource.indexOf(record)}`);

  // Ensure each row has a unique key
  const dataWithKeys = safeDataSource.map((item: any, index: number) => ({
    ...item,
    key: getRowKey(item),
  }));

  return (
    <Table
     className={`table datanew dataTable ${className || ''}`}
      rowSelection={rowSelection}
      columns={columns}
      dataSource={dataWithKeys}
      rowKey={getRowKey}
      pagination={pagination}
      loading={loading}
      showHeader={true}
    />
  );
};

export default Datatable;
